import { createContext, useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { ProductCount } from 'types/api/notification.type';
import { ProductType } from 'types/api/product.type';

import { notificationDataService } from 'services/notification.service';

export type Catalogue = {
  products: ProductType[];
  productsSet: Function;
  subProducts: ProductType[];
  subProductsSet: Function;
  notifications: ProductCount[];
  notificationsSet: (arg: ProductCount[]) => void;
  isOrderModalVisible: boolean;
  isOrderModalVisibleSet: (arg: boolean) => void;
};

const defaultState: Catalogue = {
  products: [],
  productsSet: () => null,
  subProducts: [],
  subProductsSet: () => null,
  notifications: [],
  notificationsSet: () => null,
  isOrderModalVisible: false,
  isOrderModalVisibleSet: () => null,
};

export const CatalogueContext = createContext(defaultState);

export const CatalogueProvider: React.FunctionComponent = () => {
  const [products, productsSet] = useState<ProductType[]>([]);
  const [subProducts, subProductsSet] = useState<ProductType[]>([]);
  const [notifications, notificationsSet] = useState<ProductCount[]>([]);
  const [isOrderModalVisible, isOrderModalVisibleSet] = useState<boolean>(false);

  const state: Catalogue = useMemo(
    () => ({
      products,
      productsSet,
      subProducts,
      subProductsSet,
      notifications,
      notificationsSet,
      isOrderModalVisible,
      isOrderModalVisibleSet,
    }),
    [products, subProducts, notifications, isOrderModalVisible]
  );

  useEffect(() => {
    if (products && products.length > 0) {
      const productsMapped = products.map(
        (item): ProductCount => ({
          itemCode: item.itemCode,
          mainFabricCode: item.mainFabricCode,
        })
      );

      notificationDataService.getProductCount(productsMapped).then((res) => {
        notificationsSet(res.data);
      });
    }
  }, [products]);

  return (
    <CatalogueContext.Provider value={state}>
      <Outlet />
    </CatalogueContext.Provider>
  );
};
